
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import dynamic from 'next/dynamic';
import Spinner from '@prezzee/ribbon-ui/lib/components/Spinner';
import Box from '@prezzee/ribbon-ui/lib/components/Box';
import colors from '@prezzee/ribbon-ui/lib/theme/foundations/colors';
import useAuth from 'contexts/AuthContext';

// @ts-ignore
const ExchangeRemote = dynamic(() => import('partner_exchange/App'), {
  ssr: false,
  loading: () => (
    <Box w="100%" height="500px" display="flex" alignItems="center" justifyContent="center">
      <Spinner emptyColor="gray.200" color={colors.red[400]} size="xl" />
    </Box>
  ),
});

const Exchange = props => {
  const { updateMfa } = useAuth();

  return <ExchangeRemote {...{ updateMfa, ...props }} />;
};

export default Exchange;
